import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { AppState } from '../../state/appState';
import { Observable, Subscription } from 'rxjs';
import { MerchantModel } from '../../shared/models/merchant.model';
import {
  AppStateConfigModel,
  CashcutListPaginationModel,
  TransactionListPaginationModel,
} from '../../state/appState.model';
import { SetOverviewMode } from '../../state/actions/general.actions';
import { OverviewModesEnum } from '../../shared/enum/overviewModes.enum';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  @Select(AppState.currentMerchant$)
  currentMerchant$: Observable<MerchantModel>;
  @Select(AppState.config$) currentConfig$: Observable<AppStateConfigModel>;
  @Select(AppState.overviewMode$) overviewMode$: Observable<OverviewModesEnum>;
  @Select(AppState.transactionList$)
  transactionList$: Observable<TransactionListPaginationModel>;

  public overviewModes = OverviewModesEnum;
  public subscriptions: Subscription[] = [];
  public transactions: TransactionListPaginationModel;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.transactionList$.subscribe((t) => (this.transactions = t))
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onChangeOverviewMode(mode: OverviewModesEnum): void {
    this.store.dispatch(new SetOverviewMode(mode));
  }
}
